<template>
  <div>Logout</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

export default {
  methods: {
    ...mapActions("cenario",
    [
      "removerPlanos",
      "resetRedes",
      "resetRegioes",
      "removerCenarios"
    ]),
    ...mapActions(
      "operadora",
      [
        "resetOperadora",
        "resetOperadoras",
        "resetProduto",
        "resetAdministradora",
        "resetEntidade"
      ]
    ),
    ...mapActions(
      "produto", [
        "resetProdutos",
      ]
    ),
    ...mapActions(
      "plano", [
        "resetPlanos",
        "resetGrupos",
        "resetGrupoTree",
        "resetPlanosPorRede",
        "resetValores"
      ]
    ),
  },
  async created() {
    localStorage.removeItem(process.env.VUE_APP_CLIENT_ID)
    localStorage.removeItem('cenarios')
    localStorage.removeItem('cotacao')
    localStorage.removeItem('cotacao_id')
    localStorage.removeItem('cotacao_hash')
    localStorage.removeItem('filtros')
    localStorage.removeItem('filters')
    localStorage.removeItem('toggleAllRegiao')
    localStorage.removeItem('toggleAllCidade')
    localStorage.removeItem('toggleRecomendar')
    localStorage.removeItem('showHospitais')
    localStorage.removeItem('showValores')

    this.$store.commit("resetState")

    // await this.removerPlanos();
    // await this.removerCenarios();
    // await this.resetRedes();
    // await this.resetRegioes();
    // await this.resetOperadora();
    // await this.resetOperadoras();
    // await this.resetProduto();
    // await this.resetAdministradora();
    // await this.resetEntidade();
    // await this.resetProdutos();
    // await this.resetPlanos();
    // await this.resetGrupos();
    // await this.resetGrupoTree();
    // await this.resetPlanosPorRede();
    // await this.resetValores();

    this.$router.push({name: 'login'})
  }
}
</script>

<style>

</style>
